import { HomeSurface } from "./HomeView"

export const getNextSurface = (currentSurface: HomeSurface): HomeSurface => {
    switch (currentSurface) {
        case HomeSurface.CONNECTIONS:
            return HomeSurface.DIGEST;
        case HomeSurface.DIGEST:
            return HomeSurface.CONNECTIONS;
        case HomeSurface.DIGEST_LIST:
            return HomeSurface.DIGEST;
    }
}